/**
 * moray-home.js — extras de la home MORAY (complementa iurop-sliders.js):
 *  1) [data-slider-progress]: barra de progreso bajo cada track
 *     ([data-slider-track] del mismo [data-product-slider]); ancho =
 *     fracción visible, posición = scroll. Sin overflow → .is-idle (oculta).
 *  2) [data-story]: brand story — marca is-active en el heading del panel
 *     visible (IntersectionObserver; solo clases, testeable con pestaña oculta).
 *  3) [data-look-video]: tarjeta look con vídeo — al tocar inyecta un
 *     <video controls playsinline> (nada de autoplay; el tap es gesto real).
 * Todo por delegación + guard global: el <script> se emite en varias
 * secciones y solo debe registrarse una vez.
 */
(function () {
  'use strict';

  if (window.__morayHomeInit) return;
  window.__morayHomeInit = true;

  // ---------- 1) Barras de progreso ----------
  function updateProgress(section) {
    if (!section) return;
    var wrap = section.querySelector('[data-slider-progress]');
    var track = section.querySelector('[data-slider-track]');
    if (!wrap || !track) return;
    var bar = wrap.querySelector('.moray-progress__bar');
    if (!bar) return;
    var overflow = track.scrollWidth - track.clientWidth;
    if (overflow <= 1) {
      wrap.classList.add('is-idle');
      return;
    }
    wrap.classList.remove('is-idle');
    var frac = track.clientWidth / track.scrollWidth;
    var pos = track.scrollLeft / track.scrollWidth;
    bar.style.width = (frac * 100).toFixed(2) + '%';
    bar.style.left = (pos * 100).toFixed(2) + '%';
  }

  function updateAllProgress() {
    document.querySelectorAll('[data-product-slider]').forEach(updateProgress);
  }

  // scroll no burbujea → captura (mismo patrón que iurop-sliders.js)
  document.addEventListener(
    'scroll',
    function (event) {
      var el = event.target;
      if (el.nodeType === 1 && el.hasAttribute && el.hasAttribute('data-slider-track')) {
        updateProgress(el.closest('[data-product-slider]'));
      }
    },
    true
  );

  // ---------- 2) Brand story ----------
  function initStory() {
    document.querySelectorAll('[data-story]').forEach(function (story) {
      if (story.dataset.storyReady) return;
      story.dataset.storyReady = '1';
      var links = story.querySelectorAll('[data-story-link]');
      var panels = story.querySelectorAll('[data-story-panel]');
      if (!links.length || !panels.length) return;

      // Estado unico: indice activo actual (el primero viene marcado del server)
      var current = '0';
      var setActive = function (idx) {
        idx = String(idx);
        if (idx === current) return;
        current = idx;
        // Un solo bucle exclusivo sobre TODOS los links: imposible que
        // queden dos con is-active a la vez.
        links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('data-story-link') === idx);
        });
      };

      // Ganador = el panel que contiene la LINEA MEDIA del viewport: la foto
      // nueva no manda hasta ocupar ~50% (antes cambiaba con ~45% asomando).
      // Deterministico: solo un panel puede contener la linea -> sin dobles
      // activos ni histeresis entre observers.
      var computeActive = function () {
        var mid = (window.innerHeight || document.documentElement.clientHeight) / 2;
        var winner = null;
        panels.forEach(function (panel) {
          var r = panel.getBoundingClientRect();
          if (r.top <= mid && r.bottom > mid) winner = panel.getAttribute('data-story-panel');
        });
        if (winner !== null) setActive(winner);
      };

      if ('IntersectionObserver' in window) {
        // El IO solo DESPIERTA el calculo cuando un borde de panel cruza la
        // linea media (rootMargin -50%/-50% = franja de altura 0).
        var io = new IntersectionObserver(computeActive, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
        panels.forEach(function (panel) { io.observe(panel); });
      } else {
        document.addEventListener('scroll', computeActive, { passive: true });
      }
      computeActive();

      var storyScrollRaf = 0;
      var storyScrollRunning = false;
      var previousScrollBehavior = '';
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

      var stopStoryScroll = function () {
        if (storyScrollRaf) cancelAnimationFrame(storyScrollRaf);
        storyScrollRaf = 0;
        if (storyScrollRunning) {
          document.documentElement.style.scrollBehavior = previousScrollBehavior;
          storyScrollRunning = false;
        }
      };

      var animateStoryScroll = function (top) {
        stopStoryScroll();
        var start = window.pageYOffset || document.documentElement.scrollTop || 0;
        var distance = top - start;
        if (Math.abs(distance) < 1) return;

        previousScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        storyScrollRunning = true;

        // Desplazamiento editorial: aceleración y frenado simétricos, sin el
        // salto variable del smooth-scroll nativo. La duración se adapta a la
        // distancia para que cambiar un panel o dos conserve el mismo ritmo.
        var duration = Math.min(850, Math.max(520, Math.abs(distance) * 0.72));
        var startedAt = performance.now();
        var frame = function (now) {
          var progress = Math.min(1, (now - startedAt) / duration);
          var eased = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
          window.scrollTo(0, start + distance * eased);
          if (progress < 1) {
            storyScrollRaf = requestAnimationFrame(frame);
          } else {
            window.scrollTo(0, top);
            stopStoryScroll();
          }
        };
        storyScrollRaf = requestAnimationFrame(frame);
      };

      var moveToPanel = function (link, behavior) {
        var idx = link.getAttribute('data-story-link');
        var panel = story.querySelector('[data-story-panel="' + idx + '"]');
        if (!panel) return false;
        var r = panel.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var top = window.pageYOffset + r.top - Math.max(0, (vh - r.height) / 2);
        if (document.hidden || behavior === 'auto' || (reducedMotion && reducedMotion.matches)) {
          stopStoryScroll();
          var inlineBehavior = document.documentElement.style.scrollBehavior;
          document.documentElement.style.scrollBehavior = 'auto';
          window.scrollTo(0, top);
          document.documentElement.style.scrollBehavior = inlineBehavior;
        } else {
          animateStoryScroll(top);
        }
        return true;
      };

      // Escritorio: al entrar con el ratón en un título, la historia se mueve
      // suavemente a su panel. pointerover + relatedTarget evita reiniciar la
      // animación al cruzar letras o nodos internos del mismo enlace.
      story.addEventListener('pointerover', function (event) {
        if (!window.matchMedia || !window.matchMedia('(hover: hover) and (min-width: 750px)').matches) return;
        var link = event.target.closest('[data-story-link]');
        if (!link || !story.contains(link) || (event.relatedTarget && link.contains(event.relatedTarget))) return;
        var idx = link.getAttribute('data-story-link');
        if (idx === current) return;
        moveToPanel(link, 'smooth');
      });

      // Un gesto de scroll del usuario manda sobre la transición automática.
      story.addEventListener('wheel', stopStoryScroll, { passive: true });
      story.addEventListener('touchstart', stopStoryScroll, { passive: true });

      // Clic en dos tiempos: heading NO activo -> primer clic lleva (scroll)
      // a su foto; heading ya activo -> el clic navega a la coleccion.
      story.addEventListener('click', function (event) {
        var link = event.target.closest('[data-story-link]');
        if (!link || !story.contains(link)) return;
        // Gestos de "abrir en pestana nueva" (cmd/ctrl/shift/alt/boton no
        // principal): no interceptar, que naveguen directo.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        var idx = link.getAttribute('data-story-link');
        if (idx === current) return; // activo: navegacion normal del <a>
        if (!story.querySelector('[data-story-panel="' + idx + '"]')) return;
        event.preventDefault();
        moveToPanel(link, document.hidden ? 'auto' : 'smooth');
      });
    });
  }

  // ---------- 3) Vídeo de las tarjetas look ----------
  // Solo UN vídeo sonando a la vez: pausar el resto al reproducir uno nuevo
  function pauseOtherLookVideos(except) {
    document.querySelectorAll('.iurop-ugc__video').forEach(function (v) {
      if (v !== except && !v.paused) v.pause();
    });
  }

  document.addEventListener('play', function (event) {
    var v = event.target;
    if (v && v.classList && v.classList.contains('iurop-ugc__video')) pauseOtherLookVideos(v);
  }, true); // capture: 'play' no burbujea

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-look-video]');
    if (!card || card.dataset.videoPlaying) return;
    var src = card.getAttribute('data-look-video');
    if (!src) return;
    pauseOtherLookVideos(null);
    card.dataset.videoPlaying = '1';
    var video = document.createElement('video');
    video.className = 'iurop-ugc__video';
    video.src = src;
    video.controls = true; // presencia del atributo = controles (nunca controls="false")
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'auto';
    card.appendChild(video);
    var play = card.querySelector('.iurop-ugc__play');
    if (play) play.style.display = 'none';
    // El tap es gesto de usuario → play con sonido permitido
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  });

  /* ---- Mini-galería del look ([data-look-gallery], Figma 19704:9037/9649)
     + CROSSFADE automático ([data-look-animate], Figma 19704:8783).
     Delegado en document: sobrevive re-renders. Slides = fotos apiladas con
     .is-active; la foto base (sin .moray-look-card__slide) es el estado 0. ---- */
  function setLookSlide(root, idx) {
    var slides = root.querySelectorAll('.moray-look-card__slide');
    if (!slides.length) return;
    var total = slides.length + 1; // + la foto base
    if (idx < 0) idx = 0;
    if (idx > total - 1) idx = total - 1;
    root.dataset.lgalIndex = idx;
    slides.forEach(function (sl, i) {
      sl.classList.toggle('is-active', i === idx - 1); // idx 0 = base (todas ocultas)
    });
    // Juegos de pins/tarjetas por foto: se activa el que coincide con el
    // slide (y si esa foto no tiene juego propio, se deja el primero).
    var scope = root.closest('.moray-destacado__group') || root;
    var sets = scope.querySelectorAll('[data-look-set]');
    if (sets.length) {
      var wanted = idx;
      var exists = false;
      for (var si = 0; si < sets.length; si++) {
        if (parseInt(sets[si].dataset.lookSet, 10) === wanted) { exists = true; break; }
      }
      if (!exists) wanted = 0;
      for (var sj = 0; sj < sets.length; sj++) {
        sets[sj].classList.toggle('is-set-on', parseInt(sets[sj].dataset.lookSet, 10) === wanted);
      }
    }

    var prev = root.querySelector('[data-lgal-prev]');
    var next = root.querySelector('[data-lgal-next]');
    // Patrón agencia: mostrar/ocultar por visibility (clases is-shown/is-hidden)
    if (prev) { prev.classList.toggle('is-shown', idx > 0); prev.classList.toggle('is-hidden', idx === 0); }
    if (next) { next.classList.toggle('is-hidden', idx === total - 1); next.classList.toggle('is-shown', idx < total - 1); }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lgal-prev], [data-lgal-next]');
    if (!btn) return;
    e.preventDefault();
    var root = btn.closest('[data-look-gallery]');
    if (!root) return;
    // La interacción manual GANA: detener el crossfade automático de esta card
    if (root.hasAttribute('data-look-animate')) root.dataset.lookAnimStop = '1';
    var idx = parseInt(root.dataset.lgalIndex || '0', 10);
    setLookSlide(root, idx + (btn.hasAttribute('data-lgal-next') ? 1 : -1));
  });

  // Crossfade automático: intervalo por tarjeta (data-look-interval), fade
  // 0.6s (CSS), EN LOOP, hasta 3 fotos. Un ticker único de baja frecuencia;
  // pausa con pestaña oculta y con prefers-reduced-motion (queda la 1ª foto).
  var lookReduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  // Optimización: solo animan las cards VISIBLES (IO marca lookAnimVis) y al
  // entrar en viewport se pre-decodifican sus slides (nunca funde a una foto
  // a medio cargar). IO único, observa en initAll (idempotente por dataset).
  var lookIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var root = en.target;
          root.dataset.lookAnimVis = en.isIntersecting ? '1' : '';
          if (en.isIntersecting && !root.dataset.lookAnimAt) root.dataset.lookAnimAt = String(Date.now());
          if (en.isIntersecting && !root.dataset.lookAnimWarm) {
            root.dataset.lookAnimWarm = '1';
            root.querySelectorAll('.moray-look-card__slide').forEach(function (img) {
              if (img.decode) img.decode().catch(function () {});
            });
          }
        });
      }, { rootMargin: '160px' })
    : null;

  function observeLookAnims() {
    document.querySelectorAll('[data-look-animate]').forEach(function (root) {
      if (root.dataset.lookAnimObs) return;
      root.dataset.lookAnimObs = '1';
      if (lookIO) { lookIO.observe(root); } else { root.dataset.lookAnimVis = '1'; }
    });
  }

  function slideReady(img) {
    return img && img.complete && img.naturalWidth > 0;
  }

  setInterval(function () {
    if (document.hidden) return;
    if (lookReduced && lookReduced.matches) return;
    var now = Date.now();
    document.querySelectorAll('[data-look-animate]').forEach(function (root) {
      if (root.dataset.lookAnimStop) return; // el usuario tocó una flecha
      if (lookIO && root.dataset.lookAnimVis !== '1') return; // fuera de viewport
      var interval = parseInt(root.getAttribute('data-look-interval') || '3500', 10);
      if (!interval || interval < 1000) interval = 3500;
      var last = parseInt(root.dataset.lookAnimAt || String(now), 10);
      if (now - last < interval) {
        if (!root.dataset.lookAnimAt) root.dataset.lookAnimAt = String(now);
        return;
      }
      var slides = root.querySelectorAll('.moray-look-card__slide');
      if (!slides.length) return;
      var total = Math.min(slides.length + 1, 3); // ciclo de hasta 3 fotos
      var idx = parseInt(root.dataset.lgalIndex || '0', 10);
      var nextIdx = (idx + 1) % total;
      // idx 0 = foto base (siempre cargada); slides: exigir decode completo
      if (nextIdx > 0 && !slideReady(slides[nextIdx - 1])) return;
      setLookSlide(root, nextIdx);
      root.dataset.lookAnimAt = String(now);
    });
  }, 500);

  /* ---- Popover de pin ([data-pin-pop]): chip de producto anclado al pin.
     Desktop revela por :hover (CSS, hover:hover); aquí el tap (móvil) +
     cerrar con Esc / tap fuera. El clamp fija --pop-shift para que el chip
     no desborde la card ni el viewport (transform en el CSS). ---- */
  function clampPinPop(pin) {
    var pop = pin.querySelector('.moray-look-card__pop');
    var card = pin.closest('.moray-look-card');
    if (!pop || !card) return;
    pin.style.setProperty('--pop-shift', '0px');
    pin.classList.remove('is-below');
    var pr = pop.getBoundingClientRect();
    if (!pr.width) return; // display:none (no medible)
    var cr = card.getBoundingClientRect();
    var margin = 6;
    var minLeft = Math.max(cr.left, 0) + margin;
    var maxRight = Math.min(cr.right, window.innerWidth) - margin;
    var shift = 0;
    if (pr.left < minLeft) shift = minLeft - pr.left;
    else if (pr.right > maxRight) shift = maxRight - pr.right;
    if (shift) pin.style.setProperty('--pop-shift', shift.toFixed(1) + 'px');
    // Pin muy alto: el chip se saldría por arriba de la card (overflow:hidden)
    // → volteo debajo del pin (.is-below en CSS)
    if (pr.top < cr.top + margin) pin.classList.add('is-below');
  }

  function clampAllPinPops() {
    document.querySelectorAll('[data-pin-pop]').forEach(clampPinPop);
  }

  function closePinPops(except) {
    document.querySelectorAll('[data-pin-pop].is-open').forEach(function (pin) {
      if (pin === except) return;
      pin.classList.remove('is-open');
      pin.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var pin = e.target.closest('[data-pin-pop]');
    if (pin) {
      // Pin-ENLACE (página Shop the look; en la home el pin es un <button>
      // informativo): con ratón el chip ya se ve por hover, así que el clic
      // navega. En táctil (hover:none) el PRIMER toque solo abre el chip y
      // el segundo entra a la ficha — si no, el dedo nunca vería el precio.
      var isLink = pin.tagName === 'A' && pin.getAttribute('href');
      var coarse = window.matchMedia('(hover: none)').matches;
      if (isLink && (!coarse || pin.classList.contains('is-open'))) return;
      if (isLink) e.preventDefault();
      var open = pin.classList.toggle('is-open');
      pin.setAttribute('aria-expanded', open ? 'true' : 'false');
      closePinPops(pin); // solo un popover abierto a la vez
      if (open) clampPinPop(pin);
      return;
    }
    closePinPops(null); // tap fuera cierra
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePinPops(null);
  });

  /* ---- Swipe entre fotos del look (movil): la flecha es diminuta y el gesto
     natural es arrastrar. Umbral 40px y solo si el gesto es mas horizontal
     que vertical, para no robarle el scroll a la pagina. ---- */
  (function () {
    var sx = 0, sy = 0, tracking = false, node = null;
    document.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      node = e.target.closest('[data-look-gallery]');
      if (!node) return;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!tracking || !node) return;
      tracking = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (node.hasAttribute('data-look-animate')) node.dataset.lookAnimStop = '1';
      var total = Math.min(node.querySelectorAll('.moray-look-card__slide').length + 1, 3);
      var cur = parseInt(node.dataset.lgalIndex || '0', 10);
      var nxt = dx < 0 ? cur + 1 : cur - 1;
      if (nxt < 0) nxt = total - 1;
      if (nxt > total - 1) nxt = 0;
      closePinPops(null);
      setLookSlide(node, nxt);
    }, { passive: true });
  })();

  /* ---- Pins del "Shop the look" (destacado home/PDP) anclados a la FOTO.
     Los % de los ajustes (data-pin-fx/fy) se definen SOBRE LA FOTO ORIGINAL;
     la card la recorta con object-fit: cover y su aspect cambia entre
     escritorio (433/700), movil (374/500) y el de cada foto (0.56-0.67), asi
     que un % de contenedor cae en sitios distintos por superficie — era la
     causa de "los punteros aparecen en sitios que no son". Aqui se convierte
     foto -> contenedor con la geometria real del cover, en cada resize y al
     cargar cada imagen. Scope: solo .moray-destacado (la pagina shop-the-look
     esta calibrada sobre su propio encuadre y no se toca). ---- */
  function remapLookPins() {
    document.querySelectorAll('.moray-destacado .moray-look-card, .moray-shop-page__frame.moray-look-card').forEach(function (card) {
      var cw = card.clientWidth;
      var ch = card.clientHeight;
      if (!cw || !ch) return;
      var slides = card.querySelectorAll('.moray-look-card__slide');
      var base = card.querySelector('.moray-look-card__image:not(.moray-look-card__slide)');
      var sets = card.querySelectorAll('.moray-look-card__pins');
      // Pagina shop-the-look: los pins cuelgan directos del frame (una sola
      // foto, sin juegos por slide) — se remapean contra la imagen base.
      if (!sets.length) {
        remapSet(card, base, cw, ch);
        return;
      }
      sets.forEach(function (set) {
        var n = parseInt(set.getAttribute('data-look-set') || '0', 10);
        var img = n === 0 ? base : slides[n - 1];
        if (!img) return;
        remapSet(set, img, cw, ch);
      });
    });
  }

  // Proyecta los pins de `scope` segun el recorte cover de `img` en cw x ch.
  function remapSet(scope, img, cw, ch) {
    if (!img) return;
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    if (!nw || !nh) {
      if (!img.dataset.pinRemapWait) {
        img.dataset.pinRemapWait = '1';
        img.addEventListener('load', remapLookPins, { once: true });
      }
      return;
    }
    var sc = Math.max(cw / nw, ch / nh);
    var dw = nw * sc;
    var dh = nh * sc;
    var ox = (dw - cw) / 2;
    var oy = (dh - ch) / 2;
    scope.querySelectorAll('.moray-look-card__pin').forEach(function (pin) {
      var isMobileLook = window.matchMedia('(max-width: 749px)').matches && !!pin.closest('.moray-shop-page');
      var fx = parseFloat(isMobileLook && pin.dataset.pinFxm !== undefined ? pin.dataset.pinFxm : pin.dataset.pinFx);
      var fy = parseFloat(isMobileLook && pin.dataset.pinFym !== undefined ? pin.dataset.pinFym : pin.dataset.pinFy);
      if (isNaN(fx) || isNaN(fy)) return;
      pin.style.left = (((fx / 100) * dw - ox) / cw * 100).toFixed(2) + '%';
      pin.style.top = (((fy / 100) * dh - oy) / ch * 100).toFixed(2) + '%';
    });
  }

  function initAll() {
    updateAllProgress();
    initStory();
    clampAllPinPops();
    observeLookAnims();
    remapLookPins();
  }

  window.addEventListener('resize', function () {
    updateAllProgress();
    clampAllPinPops();
    remapLookPins();
  });
  // Re-clampar cuando fuentes/imágenes asientan (el ancho del chip cambia)
  window.addEventListener('load', function () {
    clampAllPinPops();
    remapLookPins();
  });
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();
